import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Refresh from '@material-ui/icons/Refresh';
import Close from '@material-ui/icons/Close';
import ExitToApp from '@material-ui/icons/ExitToApp';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { DateAndTime, DayStepper, ConfirmDialog } from '../../components';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class AppBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLogoutConfirm: false,
    };
  }

  renderSearchBar() {
    const {
      classes,
      setOrderSearchValue,
      orderSearchValue,
      orders,
    } = this.props;

    if (!orders || orders.length < 5) {
      return null;
    }

    const searchInputProps = {
      style: { marginTop: 0, width: 300 },
    };

    return (
      <div className={classes.searchBar}>
        <TextField
          placeholder="Suche (Abholnr. / Name)"
          InputProps={searchInputProps}
          value={orderSearchValue || ''}
          onChange={e => setOrderSearchValue(e.target.value)}
        />
        <IconButton
          onClick={() => setOrderSearchValue(null)}
          disabled={!orderSearchValue}
        >
          <Close />
        </IconButton>
      </div>
    );
  }

  render() {
    const {
      classes,
      selectedMode,
      signalRconnected,
      setMode,
      preOrderDaysAheadAllowed,
      ordersStartDate,
      logout,
    } = this.props;

    const minutesToMidnight = moment.duration(moment().endOf('day').diff(moment())).asMinutes();
    const selectableDurations = [
      { value: 30, text: '30 min', id: '30', slide: true },
      { value: 60, text: '60 min', id: '60', slide: true },
      { value: minutesToMidnight, text: 'aktueller Tag', id: 'day' },
    ];

    const durationButtons = selectableDurations.map((d) => {
      const color = d.id === selectedMode ? 'secondary' : null;
      return signalRconnected
        ? (
          <Button
            key={d.value}
            variant="outlined"
            size="large"
            color={color}
            className={classes.button}
            onClick={() => setMode(d.id, null, moment().add('minute', d.value).toDate(), d.slide)}
          >
            {d.text}
          </Button>
        ) : null;
    });

    const refreshPage = () => {
      window.location.reload();
    };

    const renderRefreshButton = () => (
      <IconButton
        className={classes.iconButton}
        onClick={refreshPage}
      >
        <Refresh />
      </IconButton>
    );

    const renderMoreDayButton = () => {
      if (preOrderDaysAheadAllowed === 0) {
        return null;
      }

      return (<div className={classes.moreDayButton}>
        <Button
          variant="outlined"
          size="large"
          className={classes.button}
          color={selectedMode === 'more' ? 'secondary' : null}
          onClick={() => setMode('more', moment().startOf('day').toDate(), moment().endOf('day').toDate())}
        >
          weitere Tage
        </Button>
        {selectedMode === 'more'
          ? <DayStepper
            value={ordersStartDate}
            onChange={date => setMode('more', moment(date).startOf('day').toDate(), moment(date).endOf('day').toDate())}
          />
          : null}
      </div>)
      ;
    };

    const signalRWarning = false && signalRconnected === false
      ? <Typography color="inherit">Verbindungsprobleme zu smorder</Typography>
      : null;

    const rootClasses = classnames({
      [classes.root]: true,
      [classes.error]: signalRWarning != null,
    });

    console.log(this.state.showLogoutConfirm);

    return (
      <div className={rootClasses}>
        <div>
          <IconButton
            onClick={() => this.setState({ showLogoutConfirm: true })}
          >
            <ExitToApp classes={{ root: classes.logoutIcon }} fontSize="large" />
          </IconButton>
        </div>
        <div className={classes.titleWrapper}>
          <Typography>ONLINE BESTELLMANAGER</Typography>
        </div>
        <div className={classes.warningTextWrapper} onClick={window.location.reload}>
          {signalRWarning}
        </div>
        <div className={classes.buttonsWrapper}>
          {this.renderSearchBar()}
          {renderRefreshButton()}
          {durationButtons}
          {renderMoreDayButton()}
        </div>
        <div className={classes.dateAndTimeWrapper}>
          <DateAndTime />
        </div>
        <ConfirmDialog
          open={this.state.showLogoutConfirm}
          title="Sind Sie sicher?"
          message="Sie werden nun aus dem System ausgeloggt"
          onDismiss={() => this.setState({ showLogoutConfirm: false })}
          onAgree={() => {
            this.setState({ showLogoutConfirm: false });
            this.props.logout();
          }}
        />
      </div>
    );
  }
}


const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    background: theme.palette.error.dark,
  },
  titleWrapper: {
    flex: '1 1 auto',
  },
  dateAndTimeWrapper: {
    flex: '0 0 auto',
  },
  warningTextWrapper: {
    flex: '1',
    padding: 10,
    color: theme.palette.error.contrastText,
  },
  buttonsWrapper: {
    padding: `${10}px`,
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'flex-end',
  },
  button: {
    marginRight: 10,
    fontSize: theme.appbar.buttons.fontSize,
  },
  iconButton: {
    marginRight: 10,
    border: '1px solid rgba(0,0,0,0.23)',
  },
  moreDayButton: {
    display: 'inline',
  },
  searchBar: {
    alignItems: 'center',
    display: 'inline-flex',
    position: 'relative',
  },
  logoutIcon: {
    color: 'black',
  },
});

AppBar.propTypes = {
  selectedMode: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  signalRconnected: PropTypes.bool,
  setMode: PropTypes.func.isRequired,
  ordersStartDate: PropTypes.object,
  preOrderDaysAheadAllowed: PropTypes.number.isRequired,
  orderSearchValue: PropTypes.string,
  setOrderSearchValue: PropTypes.func,
  logout: PropTypes.func,
};

AppBar.defaultProps = {
  signalRconnected: null,
  ordersStartDate: null,
  orderSearchValue: null,
  setOrderSearchValue: () => {},
  logout: () => {},
};


export default withStyles(styles)(AppBar);
